<template>
    <section>
        <div class="row">
            <div class="col-12">
                <job-list-type @setJobOption="setJobOption($event)"></job-list-type>
            </div>
        </div>

        <div class="row" v-if="jobType === $Constants.JOB_TYPE_ORDER">
            <div class="col-12">
                <job-list-order></job-list-order>
            </div>
        </div>

        <div class="row" v-if="jobType === $Constants.JOB_TYPE_SERVICE">
            <div class="col-12">
                <job-list-service></job-list-service>
            </div>
        </div>

        <div class="row" v-if="jobType === $Constants.JOB_TYPE_CLAIM">
            <div class="col-12">
                <job-list-claim></job-list-claim>
            </div>
        </div>
    </section>    
</template>

<script>
import JobListType from '@/components/job/ListType';
import JobListOrder from '@/components/job/ListOrder';
import JobListService from '@/components/job/ListService';
import JobListClaim from '@/components/job/ListClaim';

export default {
    components: {
        JobListType,
        JobListOrder,
        JobListService,
        JobListClaim
    },
    data() {
        return {
            jobType: -1
        };
    },
    methods: {
        setJobOption(data) {
            this.jobType = data;
        }
    }
}
</script>